export const BREEDS_PATH = "breeds";
export const QUIZ_PATH = "quiz";
export const SAY_HI_PATH = "say-hi";
export const NOT_FOUND_PATH = "not-found";
export const PRIVACY_POLICY_PATH = "privacy-policy";
export const TERMS_AND_CONDITIONS_PATH = "terms-and-conditions";
